import { Component, AfterViewInit, TemplateRef, QueryList, ElementRef, ContentChildren, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { StepperService } from '../../services/stepper.service';
import { StepperDirective } from '../../directives/stepper/stepper.directive';
import { ShowDirective } from '../../directives/show/show.directive';
import * as _ from 'lodash';
import { NotifyService } from '../../services/notify.service';

@Component({
  selector: 'mapfre-auditlib-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit, AfterViewInit {

  @ContentChildren(TemplateRef) templates: QueryList<ElementRef>;
  @ContentChildren(StepperDirective) title: QueryList<StepperDirective>;
  @ContentChildren(ShowDirective) show: QueryList<ShowDirective>;
  constructor(private stepperService: StepperService, private notifyService: NotifyService) { }
  public templatesArray = { data: [] };
  public states;
  public titles;
  public shows;
  public loaded = false;
  public index = 0;

  ngOnInit() {
    this.stepperService.stepChange.subscribe((index) => {
      this.states[this.index] = false;
      this.index = (index - 1);
      this.states[this.index] = true;
    });

    this.notifyService.observer.subscribe((result) => {
      if (this.templates) {
        this.setTemplates();
      }
    });
  }


  ngAfterViewInit() {
    setTimeout(() => {
      this.setTemplates();
    }, 0);
  }

  nextStep(step) {
    if (this.index > step) {
      this.stepperService.changeStep(step + 1);
    }
  }

  setTemplates() {
    const templates = [];
    this.states = [];
    this.titles = this.title.toArray();
    this.shows = this.show.toArray();

    _.forEach(this.templates.toArray(), (step, index) => {
      if (this.shows[index].show) {
        templates.push(step);
        if (index == 0) {
          this.states.push(true);
        }
        else {
          this.states.push(false);
        }
      }
    });

    this.templatesArray.data = templates;
  }

}
